// 活动信息
const eventCode = 240651;
export function eventInfo() {
    let info = {};
    info.eventCode = eventCode;
    info.channel = "2025";
    info.autoReg = true; // 自动报名开关：true-登录后，若未报名，可选择组别报名；false-必须由后台导入报名
    info.needPsw = false;
    info.needVip = true; //true-只有VIP用户才能参加，false-所有用户都可以参加
    info.orgIds = [] // 可以参加活动的机构id，为空时所有机构都可参加
    info.bannerLinks = [{
        name: "排行榜：第1场",
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240645"
    }, {
        name: "2",
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240646"
    }, {
        name: "3", // 会员专场
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240647"
    }, {
        name: "4",
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240648"
    }, {
        name: "5", 
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240649"
    }, {
        name: "6", // 学校专场
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240650"
    }, {
        name: "7", // 会员专场
        link: "https://ix.icode.org.cn/rankBoard?eventCode=240651"
    }, {
        name: "学习平台",
        link: "https://home.icode.org.cn"
    }, {
        name: "证书下载",
        link: "https://home.icode.org.cn/myPage"
    }];
    info.rankTitle = "第七届ICode中国区预选活动";
    info.showSchoolRank = true; // 是否显示学校榜
    info.cameraTest = true;
    
    info.notice = "欢迎参加第七届ICode中国区预选活动！第7场线上选拔活动时间：4月27日（周日），各组别时间如下：<br>· 图形化小低组：19:00-20:00<br>· 图形化小高组：19:05-20:05<br>· Python小学组：19:10-20:10<br>· Python中学组：19:15-20:15";
    //info.notice = "欢迎参加第七届ICode中国区预选活动！第6场为学校专场，学校老师可以组织学生在4月7日-13日，每日8:00-18:00选择任意一个小时参与活动，注意每个人只能参与一次。";
    //info.notice += "任何不诚信的行为都将被记录，并且视情节严重取消个人或参赛学校全部成绩。";

    info.pageText = {
        title: "第七届ICode国际青少年编程活动中国区预选活动", // 主标题
        subTitle: "2025.01.01-2025.4.30", // 副标题
        // 下方单位信息
        orgList: [
            "主办单位：ICODE中国区组委会",
            "技术支持：立乐教育科技（上海）有限公司"
        ]
    };
    info.eventGameList = [{
        name: "图形化小低组", // 组别名称
        gameId: eventCode * 100 + 1, // 活动gameId
        mode: 0, // 活动模式：0-积木，1-Python
        minGrade: 0, // 组别最低年级（包含，1-12）
        maxGrade: 3 // 组别最高年级（包含，1-12）
    }, {
        name: "图形化小高组",
        gameId: eventCode * 100 + 2,
        mode: 0,
        minGrade: 4,
        maxGrade: 6
    }, {
        name: "Python小学组",
        gameId: eventCode * 100 + 11,
        mode: 1,
        minGrade: 0,
        maxGrade: 6
    }, {
        name: "Python中学组",
        gameId: eventCode * 100 + 12,
        mode: 1,
        minGrade: 7,
        maxGrade: 13
    }];
    return info;
}


// WEBPACK FOOTER //
// ./src/components/contest/2025/eventConfig.js